export function Footer() {
  return (
    <footer className="py-10 px-6 border-t border-gray-200/60">
      <div className="max-w-4xl mx-auto text-center text-sm text-gray-500 font-roboto leading-relaxed">
        <p>
          &copy; Locale &middot;{' '}
          <a
            href="mailto:info@localeapp.io"
            className="text-[#2563eb] hover:underline"
          >
            info@localeapp.io
          </a>
          &middot;{' '}
          <a href="/terms" className="text-[#2563eb] hover:underline">
            Terms of Service
          </a>
          &middot;{' '}
          <a href="/privacy" className="text-[#2563eb] hover:underline">
            Privacy Policy
          </a>
          &middot;{' '}
          <a href="/support" className="text-[#2563eb] hover:underline">
            Support
          </a>
        </p>
      </div>
    </footer>
  );
}
